import ResponseModals from "../../Common/Modals/components/ResponseModals";
import useModalHandler from "../../Common/Modals/hooks/useModalHandler";
import { setModalHandlerInstance } from "../../Common/Modals/hooks/useModalSingleton";

import LeftPanel from "./components/containers/LeftPanel";
import RightPanel from "./components/containers/RightPanel";

export default function ProviderManagement(){
    const handlers = useModalHandler();
    setModalHandlerInstance(handlers);

    return(
        <div className="flex h-full w-full flex-col justify-start items-start p-2">
            <div className="flex h-full min-h-0 w-full flex-row justify-between gap-6 p-2">
                <LeftPanel />
                <RightPanel />
            </div>
            <ResponseModals {...handlers} />
        </div>
    )
}
